module dg.objects {

    export class TextDisplayerController extends PropertyDisplayerControllerBase<string> {

    }

    dg.objects.AngularHelper.registerPropertyDisplayer(TextDisplayerController, 'emailDisplayer', {
        template: '<a ng-bind="$ctrl.value" ng-href="mailto:{{$ctrl.value}}"></a>'
    });


    dg.objects.AngularHelper.registerPropertyDisplayer(TextDisplayerController, 'urlDisplayer', {
        template: '<a ng-bind="$ctrl.value" ng-href="{{$ctrl.value}}" target="_blank"></a>'
    });

    dg.objects.AngularHelper.registerPropertyDisplayer(TextDisplayerController, 'multilineTextDisplayer', {
        template: '<p ng-bind="$ctrl.value"></p>'
    });

    dg.objects.AngularHelper.registerPropertyDisplayer(TextDisplayerController, 'textDisplayer', {
        template: ($element, $attrs: any) => {
            let template = '<span ng-bind="$ctrl.value"></span>';

            if ($attrs.showLink) {
                template = '<nav-action link="$ctrl.propMeta.links.navigate" link-type="grid" link-text="{{$ctrl.value}}"></nav-action>';
            }

            return template;
        }
    });
}
